// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"157b8886","200":"ef40f8d4","259":"44dc8d61","453":"ba4a907f","483":"42c57940","508":"a0b0b0c2","856":"ae435b4b","949":"43868f29","956":"e3c1cb9e"}[chunkId] + ".chunk.js";
};